import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BulkUserPipe } from './pipes/bulk-user-status.pipe';
import { PermissionNamePipe } from './pipes/permission-name.pipe';
import { HasPermissionPipe } from './pipes/has-permission.pipe';
import { LicensesSelectedPipe } from './pipes/licenses-selected.pipe';
import { SharedModule } from '@shared';

@NgModule({
  declarations: [
    BulkUserPipe,
    HasPermissionPipe,
    PermissionNamePipe,
    LicensesSelectedPipe,
  ],
  imports: [CommonModule, SharedModule],
  exports: [
    BulkUserPipe,
    HasPermissionPipe,
    PermissionNamePipe,
    LicensesSelectedPipe,
  ],
})
export class AuSharedModule {}
